import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MessagePlaceholder } from '@galabid/gb-dashboard/shared/ui'
import { ProfilesEntity, UsersFacade } from '@galabid/gb-dashboard/user/data-access'
import { InvoiceProfile } from 'libs/gb-dashboard/checkout/data-access/src/lib/+state/invoices.models'
import * as UsersActions from 'libs/gb-dashboard/user/data-access/src/lib/+state/users.actions'

@Component({
  selector: 'gb-message-user',
  templateUrl: './gb-message-user.component.html',
  styleUrls: ['./gb-message-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbMessageUserComponent implements OnDestroy {
  messageLoaded$ = this.usersFacade.messageLoaded$

  messageUserFormFields = {
    message_template: new FormControl('', [Validators.required]),
  }

  messageUserForm = new FormGroup(this.messageUserFormFields)

  readonly placeholders: MessagePlaceholder[] = [
    {
      key: 'USERS.MESSAGE.PLACEHOLDER.CAMPAIGN_NAME_PLACEHOLDER',
      description: 'USERS.MESSAGE.PLACEHOLDER.CAMPAIGN_NAME',
    },
    {
      key: 'USERS.MESSAGE.PLACEHOLDER.FIRST_NAME_PLACEHOLDER',
      description: 'USERS.MESSAGE.PLACEHOLDER.FIRST_NAME',
    },
    {
      key: 'USERS.MESSAGE.PLACEHOLDER.LAST_NAME_PLACEHOLDER',
      description: 'USERS.MESSAGE.PLACEHOLDER.LAST_NAME',
    },
  ]

  get message_template() {
    return this.messageUserForm.get('message_template') as FormControl
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { profile: ProfilesEntity | InvoiceProfile },
    private usersFacade: UsersFacade,
  ) {}

  submitForm() {
    this.messageUserForm.valid ? this.submitMessage() : this.onError()
  }

  submitMessage() {
    if (this.message_template?.value)
      this.usersFacade.dispatch(
        UsersActions.messageUser({
          profile: this.data.profile.uuid,
          messageTemplate: this.message_template.value,
        }),
      )
  }

  onError() {
    this.messageUserForm.markAllAsTouched()
  }

  ngOnDestroy(): void {
    this.usersFacade.dispatch(UsersActions.clearSelectedUser())
  }
}
